import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import CompanyOdsRecord from "../child/company-ods-record";

const ViewCompanyRefrigerationEquipLog = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("id", id);

    post(ApiURL.company_refrigeration_equipment_get, fd).then((res) => {
      if (res?.status) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  return (
    <>
      <h2>View Refrigeration Equip Log</h2>
      <CompanyOdsRecord records={[details]} />
    </>
  );
};

export default ViewCompanyRefrigerationEquipLog;
